import React, { Component } from 'react';
import { withLocalize } from "react-localize-redux";
import { Translate } from "react-localize-redux";
import { connect } from "react-redux";
import ComunicacionEncargo from './encargo';
import Agentes from '../Agentes/index';
import { Grid, CircularProgress } from '@material-ui/core';
import {formatMenssage } from '../../api/index';
import { fetchErrorExpediente } from '../../actions/expedientes/index';
import {BreadcrumbsItem} from "react-breadcrumbs-dynamic";
import {NavLink} from "react-router-dom";
import ApiCoag from "../../api/ApiCoag";
import {URL_GUIA,URL_MARCO_LEGAL,URL_PRECIO_UNITARIO,ID_EXPEDIENTE_CATALOGO} from "../../api/config";

class Encomenda extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeEncargo: true,
      encomenda: null,
      isLoading: true,
    }
  }

  async componentDidMount() {
    if (this.props.match && this.props.match.params && this.props.match.params.id) {
      await this.loadEncomenda(this.props.match.params.id);
    }
    else {
      this.props.fetchErrorExpediente(formatMenssage("Error url"));
      this.setState({ isLoading: false });
    }
  }

  async loadEncomenda(idExpediente) {
    /*md no queremos que vuelva a cargar mensajes*/    
    //let result = await ApiCoag.expedientes.getEncomendaActualSinObservaciones(idExpediente);
    let result=null; 
    if (idExpediente==ID_EXPEDIENTE_CATALOGO){
      result = await ApiCoag.expedientes.getEncomendaCatalogo(idExpediente);
    }
    else{
       result = await ApiCoag.expedientes.getEncomendaActualSinObservaciones(idExpediente);
    }
    if (result == 'ERROR2') {// && result.MensajesProcesado && result.MensajesProcesado.length > 0) {

      this.props.history.push("/visualizar-expediente/" + this.props.match.params.id)
    }
    else {
      this.setState({ encomenda: result });
    }
    this.setState({ isLoading: false });
  }

  handleChangeComunicacionEncargo(encomenda) {
    this.setState({ encomenda: encomenda, activeEncargo: !this.state.activeEncargo });
  }

  render() {
    return (
        <div>
            {
                this.state.isLoading
                    ? <Grid item xs={12} className="text-center">
                        <CircularProgress/>
                    </Grid>
                    : <Grid container spacing={0}>
                        <BreadcrumbsItem to={'/comunicacion/' +  this.props.match.params.id} >
                            {(this.state.encomenda && this.state.encomenda.EncomendaActual && this.state.encomenda.EncomendaActual.length > 0) ?
                                <div>
                                  <NavLink to={'/visualizar-expediente/' + this.props.match.params.id}>
                                      {/* md this.state.encomenda.EncomendaActual[0].Id_Expediente*/}
                                      { this.state.encomenda.Expediente[0].Expediente_Codigo != null ? this.state.encomenda.Expediente[0].Expediente_Codigo :  this.state.encomenda.Expediente[0].Expediente_Codigo_Estudio }
                                  </NavLink>
                                    <b style={{padding: 6}}> // </b>
                                </div>
                                :
                                <div>                                  
                                  {this.props.match.params.id != 0 ?<Translate id="languages.breadcrumb.nuevoExpediente"/> : <Translate id="languages.breadcrumb.catalogoTrabajos"/> }
                                  {this.props.match.params.id != 0 ?<b style={{padding: 6}}> - </b> : <b style={{padding: 6}}>  </b> }  
                                </div>
                            }
                            {this.props.match.params.id != 0 ? <Translate id="languages.breadcrumb.comunicacionEncargo"/> :  
                            <div>
                            <a  target="_blank"  href={URL_GUIA}> Guía de tramitación </a> | <a  target="_blank"  href={URL_PRECIO_UNITARIO}> Prezo unitario </a>| <a  target="_blank"  href={URL_MARCO_LEGAL}> Marco legal </a>  
                            </div>}
                            
                        </BreadcrumbsItem>
                       
                        <Grid item xs={12}>
                            {this.state.activeEncargo && this.state.encomenda
                                ? <ComunicacionEncargo catalogo = {this.props.match.params.id == 0? true: false} 
                                                       encomenda={this.state.encomenda}
                                                       handleChangeTipoExpediente={(encomenda) => {
                                                           this.handleChangeComunicacionEncargo(encomenda)
                                                       }}/>
                                : !this.state.activeEncargo && this.state.encomenda
                                    ? <Agentes encomenda={this.state.encomenda} isModificacion={this.props.match.params && this.props.match.params.modificado ?  this.props.match.params.modificado : false}
                                               handleAgentes={(encomenda) => {
                                                   this.handleChangeComunicacionEncargo(encomenda)
                                               }}
                                               handleAddComunicacionEncargo={() => {
                                                   this.handleAddComunicacionEncargo()
                                               }}
                                               handleBack={() => {
                                                   this.setState({activeEncargo: true})
                                               }}/>
                                    : ""}
                        </Grid>
                    </Grid>
            }
        </div>
    );
  }
}

const mapStateToProps = (state) => ({

})

const mapDispatchToProps = {        
    fetchErrorExpediente 
  };


export default connect(mapStateToProps, mapDispatchToProps)(withLocalize(Encomenda));